import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Modal, Form, Input, Button, Row, Col, Spin, AutoComplete, Collapse, Select, Popconfirm } from 'antd';
import PropTypes from 'prop-types';
import { LoadScript } from '@react-google-maps/api';
import { useTranslation, Trans } from 'react-i18next';
import debounce from 'lodash/debounce';
// import moment from 'moment';
import {  getRequest, postRequest } from '../../axios';
const { Panel } = Collapse;
const libraries = ['places'];


const SelectRouteModal = ({ isModalVisible, onClose, setIsModalVisible, selectedRow ,setState}) => {
    const [form] = Form.useForm();
    const formRef = useRef();
    const { t } = useTranslation();
    const [driverForm] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [options2, setOptions2] = useState([]);
    const [driverList, setDriverList] = useState([]);
    const [updateId, setUpdateId] = useState([]);
    // const [assignDriver, setAssignDriver] = useState([]);
    const [popConfirmVisible, setPopConfirmVisible] = useState(false);
    const { Option } = Select;
    const initialState = {
        start_street_address: null,
        start_suburb: null,
        start_state: null,
        start_postcode: null,
        start_additional_details: null,
        end_street_address: null,
        end_suburb: null,
        end_state: null,
        end_postcode: null,
        end_additional_details: null,
        packages:selectedRow,
        driver:null,
         route_name:""


    }
    const [address, setAddress] = useState(initialState);
    // const currentTime = moment().format('dddd Do of MMMM YYYY h:mm A (Z)');
    // useEffect(() => {
    //     setAddress(prevstate => ({
    //         ...prevstate,
    //         route_name: `Mukesh - ${currentTime}`
    //     }));
    //     form.setFieldsValue({ route_name: `Mukesh - ${currentTime}` });
    //     getDriverName();
    // }, []);

    useEffect(() => {
        setAddress(prevstate => ({
            ...prevstate,
            route_name: null // Initially set to null
        }));
        form.setFieldsValue({ route_name: null }); // Set initial route_name to null
        getDriverName();
    }, []);
// const handleAssignDriver = async (driverId = "", id = "") => {
//     let ids = selectedRow;
//     if (ids.length === 0) {
//         ids.push(id);
//     }
//     try {
//         let apiResponse = await postRequest("assign-package-to-driver/update/", {
//             packages: ids,
//             driver: driverId,
//         });

        
//         if (apiResponse.data.success) {
//             setUpdateId(apiResponse?.data?.id)
//             // Update the form with the selected driver
//             driverForm.setFieldsValue({ driver: driverId });
//             // Close the confirmation popup
//             setPopConfirmVisible(false);
//             // Optionally reset or update the form start_state here if needed
//         } else {

//         }
//     } catch (error) {
//         console.error("Error in API call:", error);
//     }
// };

// const [updateId, setUpdateId] = useState(null);

const handleAssignDriver = async (driverId = "", id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
        ids.push(id);
    }
    let payload = {
        packages: ids,
        driver: driverId,
    };

    // Conditionally adding updateId to the payload
    if (updateId !== null) {
        payload.id = updateId;
    }
    try {
        let apiResponse = await postRequest("assign-package-to-driver/update/", payload);
        // let apiResponse = await postRequest("assign-package-to-driver/update/", {
        //     packages: ids,
        //     driver: driverId,
        // });

        if (apiResponse.data.success) {
            setUpdateId(apiResponse?.data?.data?.id);

            // Fetch the driver's name
            // const driverName = await getDriverName(driverId);
            const driverName = apiResponse?.data?.data?.driver_name;

            // Set the route_name with the selected driver's name
            const currentTime = new Date().toLocaleString(); // You can customize the time format if needed
            const routeName = `${driverName} - ${currentTime}`;

            setAddress(prevstate => ({
                ...prevstate,
                route_name: routeName,
                driver:driverId,
                packages:selectedRow,
            }));

            form.setFieldsValue({ route_name: routeName });
            driverForm.setFieldsValue({ driver: driverId });
            setPopConfirmVisible(false);
        } else {
            console.log("API call was not successful.");
        }
    } catch (error) {
        console.error("Error in API call:", error);
    }
};

const handleCancel = () => {
        setIsModalVisible(false);
        setOptions2([]);
        setOptions([]);
        setAddress(initialState);
        form.setFieldsValue({
            start_street_address: "",
            start_suburb: "",
            start_state: "",
            start_postcode: "",
            end_street_address: "",
            end_suburb: "",
            end_state: "",
            end_postcode: "",
            start_additional_details: "",
            end_additional_details: "",
        });
        setState((prevState) => ({
            ...prevState,
    
            search: "",
          }));
    }
    const getDriverName = async () => {
        try {
            // setapiLoading(true);
            const response = await getRequest("employee/drivers-list/");

            const { data } = response.data;

            setDriverList(data);
            formRef.current.setFieldsValue(response.data.data);
            // setapiLoading(false);
        } catch (error) {
            // setapiLoading(false);
        }
    };

    const handleSearch = useCallback(debounce((value) => {
        // setLoading(true);

        const service = new window.google.maps.places.AutocompleteService();
        if (value !== "") {
            service.getPlacePredictions({ input: value }, (predictions, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
                    setOptions(predictions.map(prediction => ({
                        value: prediction.description,
                        place_id: prediction.place_id
                    })));
                    setLoading(false);
                } else {
                    setOptions([]);
                    setLoading(false);
                }

            })
        } else {
            setOptions([]);
            setLoading(false);
            setAddress(prevstate => ({
                ...prevstate,
                start_street_address: "",
                start_suburb: "",
                start_state: "",
                start_postcode: ""
            }));
            form.setFieldsValue({
                start_street_address: "",
                start_suburb: "",
                start_state: "",
                start_postcode: ""
            });
        }
    }, 300), []);
    const handleSearch2 = useCallback(debounce((value) => {
        // setLoading(true);

        const service = new window.google.maps.places.AutocompleteService();
        if (value !== "") {
            service.getPlacePredictions({ input: value }, (predictions, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
                    setOptions2(predictions.map(prediction => ({
                        value: prediction.description,
                        place_id: prediction.place_id
                    })));
                    setLoading(false);
                } else {
                    setOptions2([]);
                    setLoading(false);
                }

            })
        } else {
            setOptions2([]);
            setLoading(false);
            setAddress(prevstate => ({
                ...prevstate,
                end_street_address: "",
                end_suburb: "",
                end_state: "",
                end_postcode: ""
            }));
            form.setFieldsValue({
                end_street_address: "",
                end_suburb: "",
                end_state: "",
                end_postcode: ""
            });
        }
    }, 300), []);
    const handleSelect = (value) => {
        const selected = options.find(option => option.value === value);
        if (selected && selected.place_id) {
            const service = new window.google.maps.places.PlacesService(document.createElement('div'));
            service.getDetails({ placeId: selected.place_id }, (place, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
                    setAddress(prevstate=>({ ...prevstate,
                        start_street_address: place.formatted_address,
                        start_suburb: place.address_components.find(ac => ac.types.includes('locality'))?.long_name || '',
                        start_state: place.address_components.find(ac => ac.types.includes('administrative_area_level_1'))?.short_name || '',
                        start_postcode: place.address_components.find(ac => ac.types.includes('postal_code'))?.long_name || ''
                    }));
                    form.setFieldsValue({
                        start_street_address: place.formatted_address,
                        start_suburb: place.address_components.find(ac => ac.types.includes('locality'))?.long_name || '',
                        start_state: place.address_components.find(ac => ac.types.includes('administrative_area_level_1'))?.short_name || '',
                        start_postcode: place.address_components.find(ac => ac.types.includes('postal_code'))?.long_name || ''
                    });
                }
            });
        }
    };
    const handleSelect2 = (value) => {
        const selected = options2.find(option => option.value === value);
        if (selected && selected.place_id) {
            const service = new window.google.maps.places.PlacesService(document.createElement('div'));
            service.getDetails({ placeId: selected.place_id }, (place, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
                    setAddress(prevstate=>({...prevstate,
                        end_street_address: place.formatted_address,
                        end_suburb: place.address_components.find(ac => ac.types.includes('locality'))?.long_name || '',
                        end_state: place.address_components.find(ac => ac.types.includes('administrative_area_level_1'))?.short_name || '',
                        end_postcode: place.address_components.find(ac => ac.types.includes('postal_code'))?.long_name || ''
                    }));
                    form.setFieldsValue({
                        end_street_address: place.formatted_address,
                        end_suburb: place.address_components.find(ac => ac.types.includes('locality'))?.long_name || '',
                        end_state: place.address_components.find(ac => ac.types.includes('administrative_area_level_1'))?.short_name || '',
                        end_postcode: place.address_components.find(ac => ac.types.includes('postal_code'))?.long_name || ''
                    });
                }
            });
        }
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                handleCancel();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    },);

    const onFinish = (values) => {
        handleCancel();
    };

    const handleSubmit=async ()=>{
        // let payload = {
        //     packages: ids,
        //     driver: driverId,
        // };
    
        // Conditionally adding updateId to the payload
        // if (updateId !== null) {
        //     payload.id = updateId;
        // }
        try {
            let apiResponse = await postRequest("route/package-list-formatted/", address);
            // let apiResponse = await postRequest("assign-package-to-driver/update/", {
            //     packages: ids,
            //     driver: driverId,
            // });
    
            if (apiResponse.data.success) {
             
            
                setAddress(prevstate => ({
                    ...prevstate,
                    route_name:"",
                    start_street_address: null,
                    start_suburb: null,
                    start_state: null,
                    start_postcode: null,
                    start_additional_details: null,
                    end_street_address: null,
                    end_suburb: null,
                    end_state: null,
                    end_postcode: null,
                    end_additional_details: null,
                    packages:[],
                    driver:null,
                }));
                driverForm.resetFields(); 
                form.resetFields(); 
            handleCancel();
                
            } else {
                console.log("API call was not successful.");
            }
        } catch (error) {
            console.error("Error in API call:", error);
        }
    }
    return (
        <Modal
            title={`Add Route`}
            visible={isModalVisible}
            onCancel={handleCancel}
            footer={null}
            centered
            width={1000}
        >
            {/* <h2 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '16px' }}>
    {driverName} - {currentTime}
  
</h2> */}
            <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} libraries={libraries}>
                <Spin spinning={loading}>

                    <Form

                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                    >
                        <Row gutter={24} className='addRoutModal'>
                            <Col xs={24} md={12} className="TextFeild gutter-row">
                                {/* <Form form={driverForm} autoComplete="off" ref={formRef}>
                                    <Popconfirm
                                        className="action"
                                        title={t("pop_title_assigned_to")}
                                        okText={t("pop_ok")}
                                        cancelText={t("pop_cancel")}
                                        visible={popConfirmVisible}
                                        onConfirm={() => {
                                            driverForm.validateFields().then((values) => {
                                                handleAssignDriver(values?.driver);
                                            });
                                        }}
                                        onCancel={() => {
                                            driverForm.resetFields(); // Reset the driver form field when canceled
                                            setPopConfirmVisible(false); // Close the confirm popup
                                        }}
                                    >
                                        <Form.Item
                                            name="driver"
                                            label={t("Assign Driver")}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: t("Please select a driver!"),
                                                },
                                            ]}
                                        >
                                            <Select
                                                placeholder={t("val_driver")}
                                                showArrow
                                                showSearch
                                                optionFilterProp="children"
                                                onChange={() => setPopConfirmVisible(true)} // Open the confirm popup when a value is selected
                                            >
                                                {driverList?.map((item) => (
                                                    <Option key={item.id} value={item.id}>
                                                        {item.name}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Popconfirm>
                                </Form> */}
                                <Form form={driverForm} autoComplete="off" ref={formRef}>
    <Popconfirm
        className="action"
        title={t("pop_title_assigned_to")}
        okText={t("pop_ok")}
        cancelText={t("pop_cancel")}
        visible={popConfirmVisible}
        onConfirm={() => {
            driverForm.validateFields().then((values) => {
                handleAssignDriver(values.driver);
            });
        }}
        onCancel={() => {
            driverForm.resetFields(); // Reset the driver form field when canceled
            setPopConfirmVisible(false); // Close the confirm popup
        }}
    >
        <Form.Item
            name="driver"
            label={t("Assign Driver")}
            rules={[
                {
                    required: true,
                    message: t("Please select a driver!"),
                },
            ]}
        >
            <Select
                placeholder={t("val_driver")}
                showArrow
                showSearch
                optionFilterProp="children"
                onChange={() => setPopConfirmVisible(true)} // Open the confirm popup when a value is selected
            >
                {driverList?.map((item) => (
                    <Option key={item.id} value={item.id}>
                        {item.name}
                    </Option>
                ))}
            </Select>
        </Form.Item>
    </Popconfirm>
</Form>

                            </Col>
                            <Col xs={24} md={12} className="TextFeild gutter-row">
                                <Form.Item
                                    name="route_name"
                                    label={t("Route Name")}
                                >
                                    <Input
                                        placeholder={t("Route")}
                                        name="route_name"
                                        value={address.route_name}
                                        disabled
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>

                                <Collapse defaultActiveKey={["1"]}>
                                    <Panel
                                        header="1. Start Location"
                                        key="1"
                                        style={{ textAlign: "left" }}
                                    >
                                        <Row gutter={24}>
                                            <Col xs={24} className="TextFeild gutter-row">
                                                <Form.Item
                                                    name="start_street_address"
                                                    label={t("Street Address")}
                                                    rules={[
                                                        { required: true, message: <Trans>{t("Search Street Address")}</Trans> }
                                                    ]}
                                                >
                                                    <AutoComplete
                                                        id="start_street_address"


                                                        placeholder={t("Search Street Address")}
                                                        options={options}
                                                        onSearch={handleSearch}
                                                        onSelect={handleSelect}
                                                        value={address.start_street_address}
                                                        onChange={(value) => {
                                                            setAddress(prevstate => ({
                                                                ...prevstate,
                                                                start_street_address: value
                                                            }));
                                                            form.setFieldsValue({ start_street_address: value });
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={12} className="TextFeild gutter-row">
                                                <Form.Item
                                                    name="start_suburb"
                                                    label={t("Suburb")}
                                                    rules={[
                                                        { required: true, message: <Trans>{t("Enter suburb")}</Trans> }
                                                    ]}
                                                >
                                                    <Input
                                                        placeholder={t("suburb")}
                                                        name="start_suburb"
                                                        value={address.start_suburb}
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setAddress(prevstate => ({
                                                                ...prevstate,
                                                                start_suburb: value
                                                            }));
                                                            form.setFieldsValue({ start_suburb: value });
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={12} md={6} className="TextFeild gutter-row">
                                                <Form.Item
                                                    name="start_state"
                                                    label={t("State")}
                                                    rules={[
                                                        { required: true, message: <Trans>{t("Enter state")}</Trans> }
                                                    ]}
                                                >
                                                    <Input
                                                        placeholder={t("state")}
                                                        name="start_state"
                                                        value={address.start_state}
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setAddress(prevstate => ({
                                                                ...prevstate,
                                                                start_state: value
                                                            }));
                                                            form.setFieldsValue({ start_state: value });
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={12} md={6} className="TextFeild gutter-row">
                                                <Form.Item
                                                    name="start_postcode"
                                                    label={t("Postcode")}
                                                    rules={[
                                                        { required: true, message: <Trans>{t("Enter postcode")}</Trans> }
                                                    ]}
                                                >
                                                    <Input
                                                        placeholder={t("postcode")}
                                                        name="start_postcode"
                                                        value={address.start_postcode}
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setAddress(prevstate => ({
                                                                ...prevstate,
                                                                start_postcode: value
                                                            }));
                                                            form.setFieldsValue({ start_postcode: value });
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} className="TextFeild gutter-row">
                                                <Form.Item
                                                    name="start_additional_details"
                                                    label={t("Additional Details")}
                                                    rules={[
                                                        { required: true, message: <Trans>{t("Enter Additional Details")}</Trans> }
                                                    ]}
                                                >
                                                    <Input
                                                        placeholder={t("Enter Additional Details")}
                                                        name="start_additional_details"
                                                        value={address.start_additional_details}
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setAddress(prevstate => ({
                                                                ...prevstate,
                                                                start_additional_details: value
                                                            }));
                                                            form.setFieldsValue({ start_additional_details: value });
                                                        }}
                                                    // Adjust the number of rows as needed
                                                    />
                                                </Form.Item>
                                            </Col>

                                        </Row>




                                    </Panel>
                                </Collapse>
                            </Col>
                            <Col xs={24} md={12}>
                                <Collapse defaultActiveKey={["2"]}>
                                    <Panel
                                        header="2. End Location"
                                        key="2"
                                        style={{ textAlign: "left" }}
                                    >
                                        <Row gutter={24}>
                                            <Col xs={24} className="TextFeild gutter-row">
                                                <Form.Item
                                                    name="end_street_address"
                                                    label={t("Street Address")}
                                                    rules={[
                                                        { required: true, message: <Trans>{t("Search Street Address")}</Trans> }
                                                    ]}
                                                >
                                                    <AutoComplete
                                                        id="end_street_address"
                                                        placeholder={t("Search Street Address")}
                                                        options={options2}
                                                        onSearch={handleSearch2}
                                                        onSelect={handleSelect2}
                                                        value={address?.end_street_address}
                                                        onChange={(value) => {
                                                            setAddress(prevstate => ({
                                                                ...prevstate,
                                                                end_street_address: value
                                                            }));
                                                            form.setFieldsValue({ end_street_address: value });
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={12} className="TextFeild gutter-row">
                                                <Form.Item
                                                    name="end_suburb"
                                                    label={t("Suburb")}
                                                    rules={[
                                                        { required: true, message: <Trans>{t("Enter suburb")}</Trans> }
                                                    ]}
                                                >
                                                    <Input
                                                        placeholder={t("suburb")}
                                                        name="end_suburb"
                                                        value={address.end_suburb}
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setAddress(prevstate => ({
                                                                ...prevstate,
                                                                end_suburb: value
                                                            }));
                                                            form.setFieldsValue({ end_suburb: value });
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={12} md={6} className="TextFeild gutter-row">
                                                <Form.Item
                                                    name="end_state"
                                                    label={t("State")}
                                                    rules={[
                                                        { required: true, message: <Trans>{t("Enter state")}</Trans> }
                                                    ]}
                                                >
                                                    <Input
                                                        placeholder={t("state")}
                                                        name="end_state"
                                                        value={address.end_state}
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setAddress(prevstate => ({
                                                                ...prevstate,
                                                                end_state: value
                                                            }));
                                                            form.setFieldsValue({ end_state: value });
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={12} md={6} className="TextFeild gutter-row">
                                                <Form.Item
                                                    name="end_postcode"
                                                    label={t("Postcode")}
                                                    rules={[
                                                        { required: true, message: <Trans>{t("Enter postcode")}</Trans> }
                                                    ]}
                                                >
                                                    <Input
                                                        placeholder={t("postcode")}
                                                        name="end_postcode"
                                                        value={address.end_postcode}
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setAddress(prevstate => ({
                                                                ...prevstate,
                                                                end_postcode: value
                                                            }));
                                                            form.setFieldsValue({ end_postcode: value });
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} className="TextFeild gutter-row">
                                                <Form.Item
                                                    name="end_additional_details"
                                                    label={t("Additional Details")}
                                                    rules={[
                                                        { required: true, message: <Trans>{t("Enter Additional Details")}</Trans> }
                                                    ]}
                                                >
                                                    <Input
                                                        placeholder={t("Enter Additional Details")}
                                                        name="end_additional_details"
                                                        value={address.end_additional_details}
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setAddress(prevstate => ({
                                                                ...prevstate,
                                                                end_additional_details: value
                                                            }));
                                                            form.setFieldsValue({ end_additional_details: value });
                                                        }}

                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>


                                    </Panel>
                                </Collapse>
                            </Col>
                            <Col xs={24}>
                                <div className='btnwrp'>
                                    <Button type="primary" htmlType="submit" className="SaveGradiantBtn" onClick={()=>handleSubmit()}>
                                        {t("Submit")}
                                    </Button>
                                </div>
                            </Col>
                        </Row>


                    </Form>
                </Spin>
            </LoadScript>
        </Modal>
    );
};

SelectRouteModal.propTypes = {
    isModalVisible: PropTypes.bool.isRequired,
    setIsModalVisible: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedRow: PropTypes.func.isRequired,
    setState: PropTypes.func.isRequired,
};

export default SelectRouteModal;
